(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/normalize-race-model.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/normalize-race-model.js');
'use strict';

const _dateFns = dateFns,
  format = _dateFns.format,
  parseISO = _dateFns.parseISO;
const _svs$racing$common$co = svs.racing.common.constants,
  gameTypes = _svs$racing$common$co.gameTypes,
  gameTypeToSubProductId = _svs$racing$common$co.gameTypeToSubProductId;
const _svs$racing$common$im = svs.racing.common.imageOptions,
  ImageTypes = _svs$racing$common$im.ImageTypes,
  getImageOptions = _svs$racing$common$im.getImageOptions;
const normalizeRaceModel = _ref => {
  var _meeting$track;
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    data = _ref.data;
  const raceNumber = data.raceNumber,
    draws = data.draws,
    startTimeTentative = data.startTimeTentative,
    meeting = data.meeting,
    participants = data.participants,
    numberOfParticipants = data.numberOfParticipants,
    raceName = data.raceName;
  if (!Array.isArray(draws) || !Array.isArray(participants) || !numberOfParticipants || !meeting) {
    throw new Error('Failed to normalize race: Missing data about draws, participants and meeting');
  }
  const currentDraw = draws.find(item => item.drawNumber === drawNumber);
  if (!currentDraw) {
    throw new Error('Failed to normalize race: Can\'t find draw');
  }
  const silksFormattedDate = meeting !== null && meeting !== void 0 && meeting.date ? format(parseISO(meeting.date), 'yyyyMMdd') : undefined;
  const _mapParticipant = item => ({
    number: item.participantNumber,
    horseName: item.horseName,
    driverName: item.driverName || null,
    silkImageOptions: item.silks ? getImageOptions(item.silks, silksFormattedDate, ImageTypes.CouponSilk) : null
  });
  const subProductId = String(currentDraw.userProduct).toUpperCase();
  const isHighFive = subProductId === String(gameTypeToSubProductId[gameTypes.TOPP5]).toUpperCase();
  return {
    drawNumber,
    productName: currentDraw.productName,
    subProductId,
    isHighFive,
    closeTime: startTimeTentative,
    trackName: meeting === null || meeting === void 0 || (_meeting$track = meeting.track) === null || _meeting$track === void 0 ? void 0 : _meeting$track.trackName,
    raceNumber,
    participants: participants.map(_mapParticipant),
    productId,
    numberOfParticipants,
    raceName
  };
};
setGlobal('svs.components.sport.raceHandler.race.normalizeRaceModel', normalizeRaceModel);

 })(window);